import { useState, useEffect } from 'react';
import Axios from "axios";
import { json, Link, useLocation } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { GetJobRoles, Searchfilter, siteURL } from '../apiconstants/constants';
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useCountry } from '../contexts/countrycodecontext.js';
function formatDate(dateString) {
  return dateString.split('T')[0];
}

const GetInterviewScheduledCandidates = () => {
  let Guid="";

  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const {selectedCountry} = useCountry();
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  const [offset, setOffset] = useState(0);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [fetchedData, setFetchedData] = useState([]); // Store the fetched data
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const [showFilterModal,setShowFilterModal] = useState(false)
  const [jobRoles, setJobRoles] = useState([]);
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    jobroleid : "",
    UpdatedDate: null,
  });
  const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
         { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, // Default case
  ];
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
  const [hasNoData, setHasNoData] = useState(false);
const appliedfilter = localStorage.getItem("scheduledcandidateFilters")
const token = localStorage.getItem("jwtToken");

  const handleClick = (guid,testTypeID) => {
     let type = "";
    if(testTypeID == 2){
      type = "CodingOnlineTest"
    }
   
    else if (testTypeID == 4){
      type = "AIOnlineTest"
    }
     else if (testTypeID == 5){
      type = "Assessment"
    }
    else{
      type = "OnlineTest"
    }
    const finalURL = `${siteURL}/${type}?GuiId=${guid}`;
    navigator.clipboard.writeText(finalURL)
        .then(() => console.log('URL copied to clipboard'))
        .catch(err => console.error('Failed to copy URL: ', err));
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Test Link Copied',
          showConfirmButton: false,
          timer: 2000,
        }); 
};
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
      console.error("Error fetching job roles", error);
  }
};
  const GetCandidateList = () => {
    setIsLoading(true);

    const savedFilters = localStorage.getItem("scheduledcandidateFilters");
  let payload;

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters);
         parsedFilters.CountryID = selectedCountry;
    setFilters(parsedFilters); // Optional: sync with UI filters

    payload = {
      json: JSON.stringify(parsedFilters),
      type: "scheduled",
    };
  } else {
    // Default payload when no saved filters
    payload = {
      json: JSON.stringify({ UserGuid: Guid, CountryID: selectedCountry }),
      type: "scheduled",
    };
  }
    Axios
    .post(Searchfilter.APIURL, payload,
    { headers: { Authorization: `Bearer ${token}` }, }
    )
    .then((result) => {
  setIsLoading(false);
  if (Array.isArray(result.data)) {
    setFetchedData(result.data);
  } else {
    setFetchedData([]);
  }
})

      .catch((error) => {
        console.log("Error", error);
      });
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setOffset(0); // Reset pagination when filters change

  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setOffset(0); // Reset pagination when filters change

  };
  const handleRefresh=()=>{
    setStartDate("")
    setEndDate("")
    setSearchInput("")
    setOffset(0); // Reset pagination when filters change
    setFilters({
      UserGuid: Guid,
      jobroleid : "",
      UpdatedDate: null,
    });
      localStorage.removeItem("scheduledcandidateFilters");
    GetCandidateList();

  }
  const handleFilterSearch=()=>{
    setShowFilterModal(true);
    }
  const handleCancelSearch = () => {
    setShowFilterModal(false);
  }; 
  const jobRoleOptions = jobRoles.map((item) => ({
    value: item.jobRoleId,
    label: item.jobRole
  }));

  const handleJobRoleChange = (selectedOptions) => {
    // Convert selected options to a comma-separated string of labels
    const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", ");
    
    setFilters({ ...filters, jobroleid : jobRolesLabels });
  };

  const handleFilterChange = (selectedOption) => {
    setSelectedDateFilter(selectedOption);
    setFilters({ ...filters, UpdatedDate: selectedOption.label });

  };
  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };
  const applyFilters = () => {
    const cleanedFilters = {
      ...filters,
      UpdatedDate: filters.UpdatedDate === "Select Date Filter" ? "" : filters.UpdatedDate,
      CountryID: selectedCountry
    };
  
    // Remove empty values
    let filteredData = Object.fromEntries(
      Object.entries(cleanedFilters).filter(
        ([key, value]) =>
          value !== "" &&
          value !== null &&
          !(Array.isArray(value) && value.length === 0)
      )
    );
           localStorage.setItem("scheduledcandidateFilters", JSON.stringify(cleanedFilters));

    const payload = {
        json: JSON.stringify(filteredData),
      type: "scheduled"
    };
    

    console.log("Sending JSON:", payload);
    Axios
      .post(Searchfilter.APIURL, payload,
      { headers: { Authorization: `Bearer ${token}` }, }
      )
      .then((response) => {
        console.log("Success:", response.data);
         setShowFilterModal(false)
        if( response.data == "No Data"){
          setFetchedData([]);
        }
        else{
        setFetchedData(response.data?.filter((x)=>x.isActive == true));
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  useEffect(() => {
    GetCandidateList();
    fetchJobRoles();
  }, [selectedCountry]);

  useEffect(() => {
    const filteredData = fetchedData?.filter(candidate => {
      const name = candidate.name?.toLowerCase().includes(searchInput?.toLowerCase());
      const role = candidate.jobRole?.toLowerCase().includes(searchInput?.toLowerCase());
      const rating = candidate.rating?.toLowerCase().includes(searchInput?.toLowerCase());
      const comments = candidate.comments?.toLowerCase().includes(searchInput?.toLowerCase());
      return  (name || role || rating || comments);
    });
    if (filteredData.length === 0) {
      setHasNoData(true);
      setData([]); // clear the UI
      setPageCount(0);
      return;
    } else {
      setHasNoData(false);
    }
      const slice = filteredData.slice(offset, offset + perPage);
      const items = viewType =='grid' ? slice.map((data) => {
        return(
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.id}>
        <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 350, height: 500, borderRadius: 20 }}>
          <div className='card-header' style={{ background: "none", minHeight: 170 }}>
            <div className='row'>
              <div className='col-8'>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Name</Tooltip>)}>
                  <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.name}</b></p>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                  <h5 style={{ fontSize: 18 }}>{data.jobRole}</h5>
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="card-body">
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}><span className="tooltip2">Email</span></Tooltip>)}>
              <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-envelope" aria-hidden="true"></i> {data.email}</p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Start Date</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-calendar" aria-hidden="true"></i> {formatDate(data.startDate)}</p>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>End Date</Tooltip>)}>
              <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-calendar" aria-hidden="true"></i>{formatDate(data.endDate)}</p>
            </OverlayTrigger>
            <div className='card-footer  d-flex justify-content-between' style={{ background: "none" }}>
            <Link to={"/Employer/EditInterviewScreeningTest?guid=" + data.guiID + "&email=" + encodeURIComponent(data.email) + "&test="+(data.testTypeID)}>
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Edit</Tooltip>)}>
  <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
  </OverlayTrigger>
  </Link>
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Copy Test Link</Tooltip>)}>
  <button onClick={()=>handleClick(data.guiID,data.testTypeID)} style={{ background: "none", border: "none" }}><i className="fa fa-copy" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i></button>
  </OverlayTrigger>
  
            </div>
          </div>
        </div>
      </div>
    )})
    :
       <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
      <table className="table" 
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    tableLayout: "fixed",
    wordWrap: "break-word",
  }}>
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Job Role</th>
            <th>Email</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Actions</th>
            </tr>
        </thead>
        <tbody>
           {slice?.map((data, index) =>{
  return ( 
            <tr key={index}>
              <td>{data.name}</td>
              <td>{data.jobRole}</td>
              <td>{data.email}</td>
              <td>{formatDate(data.startDate)}</td>
              <td>{formatDate(data.endDate)}</td>
             <td>  
              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
              <Link to={"/Employer/EditInterviewScreeningTest?guid=" + data.guiID + "&email=" + encodeURIComponent(data.email) + "&test="+(data.testTypeID)}>
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Edit</Tooltip>)}>
  <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
  </OverlayTrigger>
  </Link>
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Copy Test Link</Tooltip>)}>
  <button onClick={()=>handleClick(data.guiID,data.testTypeID)} style={{ background: "none", border: "none" }}><i className="fa fa-copy" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
  </OverlayTrigger>
  </div></td>
             </tr>
           )})}
        </tbody>
      </table>
    </div>
    setData(items); // Update the filtered data
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [searchInput, startDate, endDate, fetchedData, offset, perPage,viewType]);

  return (
    <ConsultantLayout>
      <div className='container-fluid'>
      <div className='row mt-3'>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
    <h2 className="" style={{ color: "#00a7ac" }}>List of Scheduled Candidates</h2>
    <div style={{display:'flex',justifyContent:'space-between'}}>

    {showIcon === 'grid' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                    <button
                                      className="btn btn-primary mr-3"
                                      onClick={() => handleViewToggle('list')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
                                )}
                                {showIcon === 'list' && (
                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                                    <button
                                      className="btn btn-primary mr-3"
                                      onClick={() => handleViewToggle('grid')}
                                      style={{ backgroundColor: "#00a7ac" }}
                                    >
                                      <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                    </button>
                                  </OverlayTrigger>
                                )}
                
   
  </div>
  </div>
</div>
            <div className="row d-flex justify-content-between mt-3">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Job Role</Tooltip>
    )}>
        <input 
              type='text' 
              placeholder='Search by Name or Job Role' 
              value={searchInput}
              onChange={(e) => {setSearchInput(e.target.value);setOffset(0)}}
              className='form-control mt-3'
             // id="searchvendor"
            />
    </OverlayTrigger>
  </div>

  <div className="col-auto align-self-end">
  <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>{ appliedfilter == null ? "Apply Filter" : "Filter Applied" }</Tooltip>
    )}>
    <button className="btn btn-primary mt-3 mr-3" onClick={handleFilterSearch} style={{height:50}}type="button">
    <i className="fas fa-filter"></i>  { appliedfilter == null ? "Apply Filter" : "Filter Applied" }
    </button>
    </OverlayTrigger>
    </Link>
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Reset</Tooltip>
    )}>
    <button className="btn btn-primary mt-3" onClick={handleRefresh} style={{height:50}}type="button">
      <i className="fas fa-sync"></i> Reset Filter
    </button>
    </OverlayTrigger>
    </Link>
  </div>
</div>
        <hr />
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Configure Screening Test</Tooltip>)}>
      <Link to="/Employer/NonHiredCandidates">
        <button className="btn btn-primary  " style={{float:"right"}}btn-ype="button"><i className="fa fa-plus"></i></button>
      </Link>
    </OverlayTrigger>    
      </div>

      {isLoading ? (
          <center><LoadingSpinner /></center>
        ) : (
          <>
 {hasNoData ? (
  <div className="pb-5 text-center">
    <img
      title="No Data"
      className="no-data-img"
      alt="no-data-img"
      src={nodataimg}
      style={{ height: 370 }}
    />
  </div>
) : (
  <div className="row  pb-3" style={{marginTop:'70px'}}>
    {data}
  </div>
)}


          </>
        )}
    {fetchedData.length > perPage &&
        <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={10}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          disabledClassName={"disable-pagination-button"}
        />
      }
       <Modal show={showFilterModal} style={{ textAlign: 'center'}} dialogClassName="custom-modal" onHide={handleCancelSearch}>
              <Modal.Header closeButton>
                <Modal.Title style={{color:"#00a7ac"}}>filters </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className='row'>
                    
                      <div className='col-6'>
                           
             <Select
                 options={dateFilterOptions}
                 placeholder="Select Date Filter"
                 value={dateFilterOptions.find(option => option.label === filters.UpdatedDate) || null}
                 onChange={handleFilterChange}
                 className="mt-3"
                 styles={{
                   control: (provided) => ({
                     ...provided,
                     height: 100,
                     borderRadius: 10,
                     fontSize: "12px",
                   }),
                   placeholder: (provided) => ({
                     ...provided,
                     textAlign: "left",
                     fontSize: "12px",
                   }),
                   singleValue: (provided) => ({
                    ...provided,
                    textAlign: "left",
                    fontSize: "12px",
                  }),
                 }}
               />
               </div>
               <div className='col-6'>
               <Select
                       options={jobRoleOptions}
                       isMulti
                       placeholder="Select Job Roles"
                       className="mt-3"
                       value={jobRoleOptions.filter(option => 
                         filters.jobroleid .split(", ").includes(option.value.toString()) // ✅ Convert stored string back to array
                       )}
                       onChange={handleJobRoleChange}
                       styles={{
                         control: (provided) => ({
                           ...provided,
                           height: 100,
                           borderRadius: 10,
                           fontSize: "12px",
                         }),
                         placeholder: (provided) => ({
                           ...provided,
                           textAlign: "left",
                           fontSize: "12px",
                         }),
                         singleValue: (provided) => ({
                          ...provided,
                          textAlign: "left",
                          fontSize: "12px",
                        }),
                       }}
                     />
                      </div>
                </div>
               
              </Modal.Body>
              <Modal.Footer style={{marginTop:100}}>
        <Button variant="primary" onClick={handleRefresh}>
      <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
    </Button>
          <Button variant="primary" onClick={applyFilters}>Apply</Button>
          <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>

        </Modal.Footer>
            </Modal>
    </ConsultantLayout>
  );
};

export default GetInterviewScheduledCandidates;


